var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flow"},[_c('img',{staticClass:"flow-img",attrs:{"src":_vm.$oss('device/device-detail-1.png')}})])}
var staticRenderFns = []

export { render, staticRenderFns }